import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const CmsTwoTilesBlock_Box_1 = styled.div`
  flex-direction: column;
  display: flex;
  width: 100%;
  align-items: stretch;
  justify-content: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    flex-direction: row;
  }
`;
